import api from '@/api'

export default {
  namespaced: true,
  state: {
    promotions: [],
    isLoading: false
  },
  mutations: {
    SET_PROMOTIONS (state, info) {
      state.promotions = info
    },
    SET_IS_LOADING (state, bool) {
      state.isLoading = bool
    },
    RESET_PROMOTIONS (state) {
      state.promotions = []
    }
  },
  actions: {
    GET_PROMOTIONS ({ commit, state }) {
      commit('SET_IS_LOADING', true)

      api.cabinet.getPromotions()
        .then(res => {
          if (res.success) {
            commit('SET_PROMOTIONS', res.data)
          }
        })
        // .catch(err => {
        //   console.log(err)
        // })
        .finally(() => {
          commit('SET_IS_LOADING', false)
        })
    },
    RESET_PROMOTIONS_ACTION ({ commit }) {
      commit('RESET_PROMOTIONS')
    }
  }
}
